
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.797 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10c0 1.379.279 2.693.784 3.888.279.66.418.99.435 1.24.018.25-.056.524-.203 1.073L2.797 22l3.799-1.016c.549-.147.823-.22 1.073-.204.25.018.58.157 1.24.436a9.97 9.97 0 003.888.784z","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.385 12.377l.871-1.081c.367-.456.82-.88.856-1.488.01-.153-.098-.841-.314-2.218-.085-.541-.59-.59-1.028-.59-.57 0-.855 0-1.138.13-.358.163-.725.622-.806 1.007-.064.305-.016.515.078.935.403 1.783 1.348 3.544 2.812 5.009 1.465 1.464 3.226 2.409 5.01 2.811.419.095.629.143.934.079.385-.08.844-.448 1.008-.806.129-.283.129-.568.129-1.138 0-.438-.049-.943-.59-1.028-1.377-.216-2.065-.323-2.218-.315-.607.036-1.032.49-1.488.857l-1.081.87","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    